export const types = {
  SET_NAV_MENU_VISIBLE: 'SET_NAV_MENU_VISIBLE'
};
